import React, { FC, useEffect, useMemo } from 'react';
import { usePatientProfileWidget } from '../hooks/use-patient-profile-widget';
import { RouteConfig } from './route-config';

export const PatientProfileRouter: FC = () => {
  const { route } = usePatientProfileWidget();
  const component = useMemo(() => RouteConfig.find(x => x.path == route)?.component, [route]);

  return <>{component && React.createElement(component)}</>
}